// extracted by mini-css-extract-plugin
export var copyrightContainer = "Footer-module--copyrightContainer--f9b07";
export var footer = "Footer-module--footer--8dcbc";
export var footerContainer = "Footer-module--footerContainer--88188";
export var logo = "Footer-module--logo--b5f37";
export var logoContainer = "Footer-module--logoContainer--7f664";
export var span = "Footer-module--span--ec851";